import { useEffect, useState } from 'react';

import { PairingsResponse } from '~/../api/common.types';
import BattleBye from '~/components/war/battle/BattleByes';
import { useGameContext } from '~/contextProviders/GameContextProvider';
import { useGetAccount } from '~/hooks/web3/useGetAccount';
import { generateMatchups, generateRevealedKey, getOwnerAndOpponentId } from '~/utils/utils';

import BattleResult from './BattleResult';

export default function BattleResultsList({
  ownerPairings,
}: {
  ownerPairings: PairingsResponse;
}) {
  const { battle, isLoading, byesByOwner, tournamentParam } = useGameContext();
  const { data: connectedAccount } = useGetAccount();
  const [revealed, setRevealed] = useState({});

  useEffect(() => {
    const revealedCheck = {};
    if (!ownerPairings) return;
    const ownerWarriorIds = ownerPairings?.map(
      (pair) =>
        getOwnerAndOpponentId(connectedAccount?.address || '', pair)
          .ownerWarriorId
    );
    ownerWarriorIds.map((warriorId) => {
      const revealedKey = generateRevealedKey(battle, warriorId, tournamentParam);
      if (
        warriorId &&
        localStorage.getItem(revealedKey)
      ) {
        revealedCheck[warriorId] = true;
      }
    });
    setRevealed(revealedCheck);
  }, [battle, ownerPairings, connectedAccount?.address, tournamentParam]);

  let matchups = [];
  if (ownerPairings && !!ownerPairings.length && connectedAccount?.address) {
    matchups = generateMatchups(connectedAccount?.address, ownerPairings);
  }
  return (
    <div className="war__container">
      {isLoading && <div className="battle-matchups--loading">Loading...</div>}
      {!isLoading &&
        matchups &&
        !!matchups.length &&
        matchups?.map((matchup: any, index) => {
          const ownerWarriorId = matchup.ownerWarriorId;
          const opponentWarriorId = matchup.opponentWarriorId;
          if (!ownerWarriorId || !opponentWarriorId) {
            return <span key={index}></span>;
          }
          return (
            <BattleResult
              key={ownerWarriorId}
              battle={battle}
              ownerWarriorId={ownerWarriorId}
              opponentId={opponentWarriorId}
              revealed={revealed[ownerWarriorId]}
              onRevealResult={() => {
                setRevealed({ ...revealed, [ownerWarriorId]: true });
                setTimeout(() => {
                  const revealedKey = generateRevealedKey(battle, ownerWarriorId, tournamentParam);
                  localStorage.setItem(
                    revealedKey,
                    'true'
                  );
                }, 1000);
              }}
              animate={
                localStorage.getItem(
                  generateRevealedKey(battle, ownerWarriorId, tournamentParam)
                ) !== 'true'
              }
            />
          );
        })}
      {byesByOwner &&
        !!byesByOwner.length &&
        byesByOwner?.map((byeWarriorId, index) => {
          return (
            <BattleBye
              key={`${byeWarriorId}-bye-${index}`}
              ownerWarriorId={byeWarriorId}
            />
          );
        })}
    </div>
  );
}
